import helpers from "../utils/helpers";

const Form = {
  formEl: null,

  /**
   * Initialize form
   */
  init(formEl) {
    this.formEl = $(formEl);

    this.formEl.on("submit", (e) => {
      e.preventDefault();

      this.handleSubmit();
    });
  },

  /**
   * Submit form
   */
  handleSubmit() {
    this.formEl.addClass("loading");
    $(".error", this.formEl).removeClass("error");

    if (helpers.validate(this.formEl)) {
      this.recaptcha();
    } else {
      this.formEl.removeClass("loading");
    }
  },

  /**
   * Execute reCAPTCHA
   */
  recaptcha() {
    grecaptcha.ready(() => {
      grecaptcha.execute(recaptcha_key, { action: "submit" }).then((token) => {
        Form.submit(token);
      });
    });
  },

  /**
   * Send data to server
   */
  submit(token) {
    const formData = new FormData(this.formEl[0]);
    formData.append("token", token);

    this.formEl.find("button").addClass("loading");
    this.formEl.find(".form-status").addClass("hidden");

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
    })
      .done((response) => {
        if (response.success) {
          this.formEl[0].reset();

          this.formEl.find(".errors-wrap").remove();
          this.formEl.find(".form-status").removeClass("error");
        } else {
          this.formEl.find(".form-status").addClass("error");
        }

        this.formEl
          .find(".form-status")
          .text(response.data.message)
          .removeClass("hidden");
      })
      .always(() => {
        this.formEl.removeClass("loading");
        this.formEl.find("button").removeClass("loading");
      });
  },
};

export default Form;
